(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.header = document.querySelector('.section-header');
    this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
    this.headerBounds = {};
    this.setHeaderHeight();
    window.matchMedia('(max-width: 992px)').addEventListener('change', this.setHeaderHeight.bind(this));
    if (this.headerIsAlwaysSticky) {
      this.header.classList.add('shopify-section-header-sticky');
    };
    this.currentScrollTop = 0;
    this.lastScrollTop = 0;
    this.preventReveal = false;
      this.isDesktop = window.innerWidth > 992;
    this.scrollThreshold = 5;
    
    // State management flags to prevent re-animation
    this.isHeaderVisible = true;   // Is header currently visible to user
    this.isHeaderHidden = false;   // Is header currently hidden
    this.isAnimating = false;      // Is animation currently in progress
    
    this.predictiveSearch = this.querySelector('predictive-search');
    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => this.preventReveal = true;
    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);
     window.addEventListener('resize', () => {
      this.isDesktop = window.innerWidth > 992;
    });
    this.createObserver();
  }
  
  setHeaderHeight() {
    document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
  }

  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });
    observer.observe(this.header);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    
    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
    
    // Calculate scroll direction
    const scrollDifference = Math.abs(scrollTop - this.lastScrollTop);
    const isScrollingDown = scrollTop > this.lastScrollTop;
    const isScrollingUp = scrollTop < this.lastScrollTop;
    
    // Desktop behavior with state management
    if (this.isDesktop) {
      
      // Scrolling DOWN - Hide header only if it's currently visible
      if (isScrollingDown && scrollTop > this.headerBounds.bottom && scrollDifference > this.scrollThreshold) {
        this.header.classList.add('scrolled-past-header');
        
        // Only hide if header is visible and not already animating
        if (this.isHeaderVisible && !this.isHeaderHidden && !this.isAnimating) {
          requestAnimationFrame(this.hide.bind(this));
        }
      }
      
      // Scrolling UP - Show header only if it's currently hidden
      else if (isScrollingUp && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        
        // Only reveal if header is hidden and not already animating
        if (!this.isHeaderVisible && this.isHeaderHidden && !this.isAnimating) {
          requestAnimationFrame(this.reveal.bind(this));
        }
      }
      
      // At top of page - Reset header
      else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }
    }
    // Mobile behavior - original logic
    else if (!this.isDesktop) {
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventHide) {
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }
    }
    
    this.lastScrollTop = scrollTop;
    this.currentScrollTop = scrollTop;
  }

  hide() {
    if (this.headerIsAlwaysSticky) return;
    
    // Set animating flag
    this.isAnimating = true;
    
    // Remove animate class and hide
    this.header.classList.remove('animate');
    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    
    // Update state flags
    this.isHeaderVisible = false;
    this.isHeaderHidden = true;
    
    // Clear animating flag after transition completes
    setTimeout(() => {
      this.isAnimating = false;
    }, 400);
    
    this.closeMenuDisclosure();
    this.closeSearchModal();
  }

  reveal() {
    if (this.headerIsAlwaysSticky) return;
    
    // Set animating flag
    this.isAnimating = true;
    
    // Remove hidden and add reveal animation
    this.header.classList.remove('shopify-section-header-hidden');
    this.header.classList.add('shopify-section-header-sticky', 'animate');
    
    // Update state flags immediately
    this.isHeaderVisible = true;
    this.isHeaderHidden = false;
    
    // Remove animate class after animation completes
    setTimeout(() => {
      this.header.classList.remove('animate');
      this.isAnimating = false;
    }, 400);
  }

  reset() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    
    // Reset all state flags
    this.isHeaderVisible = true;
    this.isHeaderHidden = false;
    this.isAnimating = false;
  }

  closeMenuDisclosure() {
    this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
    this.disclosures.forEach(disclosure => disclosure.close());
  }

  closeSearchModal() {
    this.searchModal = this.searchModal || this.header.querySelector('details-modal');
  }
}
customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
